import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import useStyles from "./styles";
import LoginForm from "../../components/Forms/LoginForm";
import ForgotPasswordForm from "../../components/Forms/ForgotPasswordForm";

function Login(props) {
  var classes = useStyles();

  // declared Local State @author Sagar
  const [toggle, setToggle] = useState(false);

  // Toggle fucntion to switch betweens forms @author Sagar
  function toggleButton() {
    setToggle(!toggle);
  }

  return (
    <div className={classes.container}>
      <div className={classes.logotypeContainer}></div>
      <div className={classes.formContainer}>
        {!toggle ? (
          <LoginForm toggle={toggleButton} properties={props} />
        ) : (
          <ForgotPasswordForm toggle={toggleButton} props={props} />
        )}
      </div>
    </div>
  );
}

export default withRouter(Login);
